import { objToUrl, urlToMap } from '@/pages/opinion/utils/url';
import { dealwithParams } from '.';
import { defaultFilterValue, setUrlParamsKeys, urlParamsFormatMap } from '../constants';
import { resumeDateTime } from './time';
import { gameInfoType } from '@op/types/common';
import * as CryptoJS from 'crypto-js';
import { cloneDeep } from 'lodash-es';
import { createShortUrl } from '@op/services';
import { dealwithChannelToSave } from './channel';
import { notification } from 'tea-component';
import { DBO_U } from '@op/utils/format';
// 处理老版本的保存记录
const dealwithHistory = (filter: any, isMobile: boolean) => {
  const {
    currentTime,
    start_time,
    end_time,
    time_value,
    date_type,
    dateType,
    sentiment,
    reviews_rating,
    reviews_rating_pc,
    social_media_by_account,
    social_media_by_keyword,
    keyword,
    hero,
    hashtag,
    keyword_en,
    ...otherFilter
  } = filter || {};
  const { start_time: realStartTime, end_time: realEndTime } = resumeDateTime(
    currentTime?.[0] || start_time,
    currentTime?.[1] || end_time,
    dateType || date_type,
    time_value,
  );
  // 老版本还有2，4分，后期改变只有1，3，5分
  const realSentiment =
    sentiment?.filter((item: number) => [1, 3, 5].includes(item)) || [];
  const realReviewsRating =
    (isMobile ? reviews_rating : reviews_rating_pc) || reviews_rating;

  // 处理渠道信息
  const params = dealwithParams(filter);

  return {
    ...defaultFilterValue(),
    ...otherFilter,
    date_type: date_type || dateType,
    start_time: realStartTime,
    end_time: realEndTime,
    sentiment: realSentiment,
    reviews_rating: realReviewsRating || [],
    keyword: hashtag || keyword || [],
    keyword_en: hero || keyword_en || [],
    ...params,
  };
};

export function dealwithHistoryToRender(filter: any, isMobile: boolean) {
  if (filter === null) {
    return filter;
  }
  return dealwithHistory(filter, isMobile);
}

export function setParamsToUrl(
  params: { [key: string]: any },
  fixedHeader: any,
) {
  const { href, pathname } = window.location;
  const dataMap = urlToMap(href);

  const obj: any = setUrlParamsKeys.reduce((pre, cur) => {
    const value = params[cur];
    if (Array.isArray(value) ? value.length > 0 : value) {
      return { ...pre, [cur]: value };
    }
    return pre;
  }, {});

  if (['All', '全部'].includes(fixedHeader.channel)) {
    delete obj.channel_social;
    delete obj.channel_comments;
    delete obj.channel_news;
    delete obj.channel_securitys;
    delete obj.channel_type;
    delete obj.channel;
  }

  const urlParams = objToUrl({ gameid: dataMap.get('gameid'), ...obj });
  const url = `${pathname}?${urlParams}`;
  window.history.replaceState(null, '', url);
}

export const dealwithCacheFilter = (
  filterValue: any,
  beforeCacheDealwithData = (data: any) => data,
) => {
  const value = cloneDeep(filterValue);
  const { isKeywordFilter, keyword, allCompetitorGame, ...otherFilter } = value;
  // 处理keyword的特殊情况
  if (isKeywordFilter) {
    otherFilter.keyWords = keyword;
  }
  // 处理竞品游戏的特殊情况
  if (allCompetitorGame) {
    otherFilter.games = ['99999'];
  }
  const cache = beforeCacheDealwithData(otherFilter);

  return {
    flag: !!cache,
    value: cache === true ? otherFilter : cache,
    originValue: otherFilter,
  };
};

function createShortId(filter: any, gameInfo: gameInfoType) {
  try {
    const { href, pathname } = window.location;
    const dataMap = DBO_U.queryObj(href);

    let newFilter = cloneDeep(filter);
    newFilter = {
      ...newFilter,
      ...gameInfo,
      createTime: Date.now(),
      salt: Math.random(),
    };
    const text = JSON.stringify(newFilter);
    const md5 = CryptoJS.MD5(text).toString();

    // 移除 urlParamsFormatMap 中定义的长链接筛选项参数
    const filterKeys = Object.keys(urlParamsFormatMap);
    const remainParams: Record<string, any> = {};
    Object.keys(dataMap).forEach((key) => {
      if (!filterKeys.includes(key)) {
        remainParams[key] = dataMap[key];
      }
    });

    const urlParams = objToUrl({
      ...remainParams,
      shortid: md5,
    });

    return {
      shortId: md5,
      urlParams,
      pathname,
      params: JSON.stringify(dealwithChannelToSave(filter)),
    };
  } catch (error) {
    return {};
  }
}

export function setShortUrl(filter: any, gameInfo: gameInfoType) {
  const { shortId, urlParams, pathname, params } = createShortId(
    filter,
    gameInfo,
  );
  if (shortId) {
    createShortUrl({ short_url: shortId, params }).catch(() => {});
    window.history.replaceState(null, '', `${pathname}?${urlParams}`);
  }
}

export async function asyncCreateShortUrl({
  filter,
  gameInfo,
  updateUrl = true,
  errorText,
  cancelFunc = () => {},
}: {
  filter: any;
  gameInfo: gameInfoType;
  updateUrl: boolean;
  errorText?: string;
  cancelFunc?: (cancel: any) => void;
}) {
  const { originValue } = dealwithCacheFilter(filter);
  const { shortId, params, urlParams, pathname } = createShortId(
    originValue,
    gameInfo,
  );

  if (updateUrl) {
    window.history.replaceState(null, '', `${pathname}?${urlParams}`);
  }

  return await createShortUrl({ short_url: shortId, params }, cancelFunc).catch(
    (_error: any) => {
      notification.error({
        description: errorText,
      });
    },
  );
}
